import { Injectable, Signal, signal, WritableSignal } from '@angular/core';
import {
  CatalogResponse,
  ReferenceCategoryEnum,
  ReferenceDataStore,
  referenceDataStoreInitialValue,
  ReferenceValue
} from './reference.model';

@Injectable({
  providedIn: 'root'
})
export class ReferenceStore {
  private readonly _referenceStore: WritableSignal<ReferenceDataStore> = signal(referenceDataStoreInitialValue);
  referenceList: Signal<ReferenceDataStore> = this._referenceStore;

  private setNationalities(referenceValueList: ReferenceValue[]): void {
    this._referenceStore().nationalities = referenceValueList;
  }

  private setCountries(referenceValueList: ReferenceValue[]): void {
    this._referenceStore().countries = referenceValueList;
  }

  private setJuridicForms(referenceValueList: ReferenceValue[]): void {
    this._referenceStore().juridicForms = referenceValueList;
  }

  private setMetropolitanDepartments(referenceValueList: ReferenceValue[]): void {
    this._referenceStore().metropolitanDepartments = referenceValueList;
  }

  private setAbroadDepartments(referenceValueList: ReferenceValue[]): void {
    this._referenceStore().abroadDepartments = referenceValueList;
  }

  private setSubStatus(referenceValueList: ReferenceValue[]): void {
    this._referenceStore().subStatus = referenceValueList;
  }

  private setIdentityPieceTypes(referenceValueList: ReferenceValue[]): void {
    this._referenceStore().identityPieceType = referenceValueList;
  }

  private setHabitations(referenceValueList: ReferenceValue[]): void {
    this._referenceStore().habitation = referenceValueList;
  }

  private setCoHolderTypes(referenceValueList: ReferenceValue[]): void {
    this._referenceStore().coholderType = referenceValueList;
  }

  private setFamilySituations(referenceValueList: ReferenceValue[]): void {
    this._referenceStore().familySituation = referenceValueList;
  }

  private setBankTypes(referenceValueList: ReferenceValue[]): void {
    this._referenceStore().bankType = referenceValueList;
  }

  setProfessionCode(referenceValueList: ReferenceValue[]): void {
    this._referenceStore().professionCode = referenceValueList;
  }

  setContractCode(referenceValueList: ReferenceValue[]): void {
    this._referenceStore().contractCode = referenceValueList;
  }

  isStoreFull(): boolean {
    return !!(
      this._referenceStore().nationalities.length &&
      this._referenceStore().countries.length &&
      this._referenceStore().juridicForms.length &&
      this._referenceStore().metropolitanDepartments.length &&
      this._referenceStore().abroadDepartments.length &&
      this._referenceStore().subStatus.length &&
      this._referenceStore().identityPieceType.length &&
      this._referenceStore().habitation.length &&
      this._referenceStore().coholderType.length &&
      this._referenceStore().familySituation.length &&
      this._referenceStore().bankType.length
    );
  }

  storeReferenceValue(catalog: CatalogResponse): void {
    switch (catalog.catalogId) {
      case ReferenceCategoryEnum.NATIONALITY:
        this.setNationalities(catalog.referenceValueDTOList);
        break;
      case ReferenceCategoryEnum.COUNTRY:
        this.setCountries(catalog.referenceValueDTOList);
        break;
      case ReferenceCategoryEnum.JURIDIC_FORM:
        this.setJuridicForms(catalog.referenceValueDTOList);
        break;
      case ReferenceCategoryEnum.METROPOLITAN_DEPARTMENT:
        this.setMetropolitanDepartments(catalog.referenceValueDTOList);
        break;
      case ReferenceCategoryEnum.ABROAD_DEPARTMENT:
        this.setAbroadDepartments(catalog.referenceValueDTOList);
        break;
      case ReferenceCategoryEnum.SUB_STATUS:
        this.setSubStatus(catalog.referenceValueDTOList);
        break;
      case ReferenceCategoryEnum.IDENTITY_PIECE_TYPE:
        this.setIdentityPieceTypes(catalog.referenceValueDTOList);
        break;
      case ReferenceCategoryEnum.HABITATION:
        this.setHabitations(catalog.referenceValueDTOList);
        break;
      case ReferenceCategoryEnum.CO_HOLDER_TYPE:
        this.setCoHolderTypes(catalog.referenceValueDTOList);
        break;
      case ReferenceCategoryEnum.FAMILY_SITUATION:
        this.setFamilySituations(catalog.referenceValueDTOList);
        break;
      case ReferenceCategoryEnum.BANK_TYPE:
        this.setBankTypes(catalog.referenceValueDTOList);
        break;
      default:
        break;
    }
  }
}
